import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateBlogTag } from "../../api/apiBlogTags";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لتحديث وسام مدونة
 */
export function useUpdateBlogTag() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updateBlogTagMutate,
        isPending,
    } = useMutation({
        mutationFn: ({ id, data }) => updateBlogTag(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-tags"] });
            navigate('/blog/tags');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update blog tag");
        },
    });

    return {
        updateBlogTagMutate,
        isPending,
    };
}
